// ═══════════════════════════════════════════════════════════════
// P8 — Job-level named constants
//
// A constant is an author-declared named value (number / text / date) that
// rule authors reference in conditions (`{ type: 'constant', name }`) and in
// expressions (`{const.<name>}`). Declarations ride the draft/publish/version
// lifecycle for free — they live on the V3 content root and are flattened onto
// the legacy view (so every runtime ctx site reaching content via
// `loadPublishedContent` can read them without an extra query).
// ═══════════════════════════════════════════════════════════════
/** Author-chosen constant name: a leading letter then letters/digits/underscore. */
const CONSTANT_NAME_RE = /^[a-zA-Z][a-zA-Z0-9_]*$/;
export function isValidConstantName(name) {
    return CONSTANT_NAME_RE.test(name);
}
/** Flatten a content blob's declared constants into a plain `{name: value}` map
 *  for EvalContext population. Reads the `constants` node off either the V3 root
 *  or the flattened legacy view (both carry it). A malformed / absent node reads
 *  as an empty map — never crashes or lies to a rule. */
export function constantsMap(content) {
    const raw = content.constants;
    if (raw == null || typeof raw !== 'object' || Array.isArray(raw))
        return {};
    const out = {};
    for (const [name, decl] of Object.entries(raw)) {
        if (decl == null || typeof decl !== 'object')
            continue;
        const value = decl.value;
        if (typeof value === 'string' || typeof value === 'number')
            out[name] = value;
    }
    return out;
}
//# sourceMappingURL=constants.js.map